module.exports = __webpack_public_path__ + "static/img/guanyuwomen.cbcfe367.png";